import Link from "next/link";

import { useTranslation } from "../../core/translation.core";
import LayoutGridIcon from "../../icons/posicons/layoutGrid.icon";

export default function ProductHomeLink() {
  const { t, msg } = useTranslation();

  return (
    <Link
      id="nav-products"
      href="/"
      className="bg-white dark:bg-her-darkblue2 dark:text-white py-2 px-3 rounded-lg flex-center gap-3 w-fit"
    >
      <LayoutGridIcon className="text-her-mysticMaroon w-6 h-6" />
      <p>{t(msg.posMenuItems.products)}</p>
    </Link>
  );
}
